import React, { FC, Fragment } from "react";
import styles from "./SignupDocuments.module.css";
import Image from "next/image";
import Link from "next/link";
import { useWebTranslation } from "translations";
import Gutter from "ui-kit/Gutter";
import { Typography } from "ui-kit/Typography";
import { FlexRow } from "ui-kit/Layout/Flex";

type SignupDocumentsProps = {
  documents: { title: string; url: string }[];
};

const SignupDocuments: FC<SignupDocumentsProps> = ({ documents }) => {
  const { t } = useWebTranslation();
  return (
    <div className={styles.container}>
      <Typography variant="body3" color="grey400">
        <strong>{t("global.recommended_documents")}</strong>
      </Typography>
      <Gutter size={3} />
      {documents.map((document) => (
        <Fragment key={document.url}>
          <Link href={document.url} target="_blank">
            <FlexRow justifyContent="space-between">
              <Typography>{document.title}</Typography>
              <Image
                src="/images/icons/external-link-grey.svg"
                alt="external-link"
                width={24}
                height={24}
              />
            </FlexRow>
          </Link>
          <div className={styles.divider} />
        </Fragment>
      ))}
    </div>
  );
};

export default SignupDocuments;
